// extracted by mini-css-extract-plugin
var _1 = "FieldBaseDescription_fluid__8743f";
var _2 = "FieldBaseDescription_root__af023";
export { _1 as "fluid", _2 as "root" }
